/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisterModel } from '../../models/register-model';
import { SdkToken } from '../../models/sdk-token';

export interface ExternalSdkAuthTokenProfileIdPost$Params {

/**
 * The member profile identifier.
 */
  profileId: string;
  
    /**
     * Registration details (date of birth, gender) to persist before issuing the token.
     */
    body?: RegisterModel
}

export function externalSdkAuthTokenProfileIdPost(http: HttpClient, rootUrl: string, params: ExternalSdkAuthTokenProfileIdPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<SdkToken>> {
  const rb = new RequestBuilder(rootUrl, externalSdkAuthTokenProfileIdPost.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<SdkToken>;
    })
  );
}

externalSdkAuthTokenProfileIdPost.PATH = '/External/SDKAuthToken/{profileId}';
